// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__rgZxc","footer":"ModalCreateQualiphyProcedure_footer__2A8bi","additionData":"ModalCreateQualiphyProcedure_additionData__3HJRE"};